import { KoType } from '@ecm/portfolio';
import { Link } from '@ecm/router';

export class KoContractViewModel {
    public typeKoContract: KoType;
    public textKoContract: string;
    public hideButtonKoContract = false;
    public isWarningAlert = true;
    public linkLabel?: string;
    public orangeLinkLabel?: string;
    public soshLinkLabel?: string;
    public link?: Link;
}
